export const anjsealScript = (id: string) => {
  return `
    !(function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = 1;
        t.defer = true;
        t.src = a;
        t.id = x;
        t.onload = execCactusEvents('anjseal');
        f.parentNode.insertBefore(t, f);
      }
    })(
      document.createElement("script"),
      document.getElementsByTagName("script")[0],
      "https://${id}.snippet.anjouangaming.org/anj-seal.js?nocache=1",
      "anjseal-script"
    );`;
};
